import { getLocale } from "../runtime";

const da_productusp3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tilfredshedsgaranti`
};

const en_productusp3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Satisfied customer guarantee`
};

const es_productusp3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Garantía de satisfacción`
};

const fi_productusp3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tyytyväisyystakuu`
};

const nb_productusp3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Fornøyd kunde-garanti`
};

const sv_productusp3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Nöjd kund-garanti`
};

const productusp3 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_productusp3(inputs)
	if (locale === "en") return en_productusp3(inputs)
	if (locale === "es") return es_productusp3(inputs)
	if (locale === "fi") return fi_productusp3(inputs)
	if (locale === "nb") return nb_productusp3(inputs)
	if (locale === "sv") return sv_productusp3(inputs)
	return "productUsp3";
};

export { productusp3 as "productUsp3" };